import {
  flexRender,
  getCoreRowModel,
  useReactTable,
  getFilteredRowModel,
} from "@tanstack/react-table";
import { Table as BTable } from "react-bootstrap";
import { TableCell } from "../Elements/TableCell";
import Filter from "./Filter";
import { useState } from "react";

const EventsTable = ({ columns, events, deleteEvent }) => {
  const [columnFilters, setColumnFilters] = useState([]);

  const table = useReactTable({
    data: events,
    columns,
    state: {
      columnFilters,
    },
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    onColumnFiltersChange: setColumnFilters,
    meta: {
      deleteEvent,
    },
    filterFns: {
      resultFilterFn: (row, columnId, filterValue, addMeta) => {
        return String(row.original.success) === String(filterValue);
      },
    },
  });

  return (
    <BTable responsive hover size="md">
      <thead>
        {table.getHeaderGroups().map((headerGroup) => (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map((header) => (
              <th key={header.id} colSpan={header.colSpan}>
                {header.isPlaceholder ? null : (
                  <>
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
                    {header.column.getCanFilter() ? (
                      <div>
                        <Filter column={header.column} />
                      </div>
                    ) : null}
                  </>
                )}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody>
        {table.getRowModel().rows.map((row) => (
          <tr key={row.id}>
            {row.getVisibleCells().map((cell) => (
              <TableCell key={cell.id}>
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </TableCell>
            ))}
          </tr>
        ))}
      </tbody>
    </BTable>
  );
};

export default EventsTable;
